import getDataSelector from 'core/utils/getDataSelector'
import DataKeys from 'k8s/DataKeys'

export const regionsMetadataSelector = getDataSelector<DataKeys.RegionsMetadata>(
  DataKeys.RegionsMetadata,
)

// export const regionsMetadataSelector = createSharedSelector(
//     getDataSelector<DataKeys.RegionsMetadata>(DataKeys.RegionsMetadata),
//     (regionsMetadata, regions) => {
//       return regionsMetadata.map((rm) => {
//         return {
//             ...rm,
//         }
//       })
//     },
//   )
